import { render, staticRenderFns } from "./Wp_mt_share_page.vue?vue&type=template&id=783e0b56&scoped=true&"
import script from "./Wp_mt_share_page.vue?vue&type=script&lang=js&"
export * from "./Wp_mt_share_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e0b56",
  null
  
)

export default component.exports